import { render, staticRenderFns } from "./p-datagrid.vue?vue&type=template&id=36af7a80&"
import script from "./p-datagrid.vue?vue&type=script&lang=js&"
export * from "./p-datagrid.vue?vue&type=script&lang=js&"
import style0 from "./p-datagrid.vue?vue&type=style&index=0&id=36af7a80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports